import { IconCheck } from '@tabler/icons-react'
import * as motion from 'motion/react-client'

import Text from 'components/ui/text'
import { ButtonCTA } from 'components/ui/button-cta'
import HighFiveIllustration from 'features/onboarding/assets/high-five-illustration'
import {
  ONBOARDING_STEPS,
  TRANSLATION_KEYS,
} from 'features/onboarding/config/steps'
import { ONBOARDING_STEP_TRANSITION_ANIMATION } from 'features/onboarding/constants'
import { translate } from 'utils/translation'

interface Step7Props {
  onClose: () => void
}

export const Step7 = ({ onClose }: Step7Props) => {
  const doneButtonText = translate(TRANSLATION_KEYS.doneButton)

  return (
    <div className="tw-mx-auto tw-flex tw-max-w-[640px] tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-pt-8">
      <HighFiveIllustration role="img" aria-label="High five illustration" />

      <motion.div
        className="tw-flex tw-flex-col tw-gap-3 tw-text-center"
        variants={ONBOARDING_STEP_TRANSITION_ANIMATION.variants}
        initial={ONBOARDING_STEP_TRANSITION_ANIMATION.initial}
        animate={ONBOARDING_STEP_TRANSITION_ANIMATION.animate}
        exit={ONBOARDING_STEP_TRANSITION_ANIMATION.exit}
        transition={ONBOARDING_STEP_TRANSITION_ANIMATION.transition}
      >
        <Text
          as="h2"
          className="tw-text-black-100 tw-m-0 tw-text-2xl tw-font-bold sm:tw-text-5xl"
        >
          {translate(ONBOARDING_STEPS.step7.title)}
        </Text>
        <Text className="tw-m-0 tw-text-lg tw-text-zinc-500">
          {translate(ONBOARDING_STEPS.step7.description)}
        </Text>
      </motion.div>

      <motion.div
        variants={ONBOARDING_STEP_TRANSITION_ANIMATION.variants}
        initial={ONBOARDING_STEP_TRANSITION_ANIMATION.initial}
        animate={ONBOARDING_STEP_TRANSITION_ANIMATION.animate}
        exit={ONBOARDING_STEP_TRANSITION_ANIMATION.exit}
        transition={ONBOARDING_STEP_TRANSITION_ANIMATION.transition}
      >
        <ButtonCTA size="xl" onClick={onClose} aria-label={doneButtonText}>
          <IconCheck />
          {doneButtonText}
        </ButtonCTA>
      </motion.div>
    </div>
  )
}
